import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage, ArticleSectionHeader } from 'cityads-v3/components/Article';

export default function AgentCabinet(props) {
  const { t } = useTranslation(['AgentCabinet']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.png')}
        caption={t('imageCaption')}
      />

      <ArticleSectionHeader>
        {t('sectionHeader')}
      </ArticleSectionHeader>

      {tArray(t, 'p2', 'p')}

      <p>
        <Trans t={t} i18nKey={'p3'}>
          You can find more details on conditions and bonuses of the CityAds
          agent accounts <a href="https://cityads.com/webmaster/office/agent_cabinet">here</a>.
        </Trans>
      </p>
    </Article>
  );
}
